import styles from "../../styles/message.module.scss";

import { Icon } from "./core/Icon";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Message = ({
  type = "info",
  title,
  text,
  children,
  className,
  icon = true
}) => {
  const Icons = {
    info: <Icon name="exclamation-circle" size="1x" light />,
    danger: <Icon name="exclamation-circle" size="1x" light />,
    warning: <Icon name="exclamation-circle" size="1x" light />,
  };

  return (
    <div
      className={css({
        messageContainer: true,
        [styles[type]]: true,
        [className]: className,
      })}
    >
      {icon && <div className={styles.icon}>{Icons[type]}</div>}
      <div className="d-flex flex-column align-start">
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.text}>
          {text ? <span>{text}</span> : children}
        </div>
      </div>
    </div>
  );
};
